import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from '@ordersnproducts/modules/order-builder/reducers';

export const getPumpPrimerState = createSelector(getRmsSpecificationPage, ({ PumpPrimerMixState }) => PumpPrimerMixState);
